module.exports = __webpack_public_path__ + "images/FUSA_icons/018-yen.8c9888a27d94095e6671a9e45b4e5b5e.svg";